import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { joinClasses } from 'utils/utils';
import { track } from 'utils/tracking';
import pure from 'utils/pure';
import s from 'components/shared/theaters/providerSelection.sss';


export default @pure class ProviderSelection extends Component {

	selectProvider(provider) {
		Store.emit(actions.SELECT_PROVIDER, provider);
		if (provider) {
			track({ a: 'selected_ticket_provider', l: provider, useCustomPageTrack: true });
		}
	}

	render(props) {
		const {
			appData,
			cinemaLogo,
			providers,
			selectedProvider
		} = props;

		if (!providers || providers.length <= 1) {
			return <div />;
		}

		return (
			<div class={joinClasses(props.class, s.providers)}>
				{providers.map(provider => {
					const pClass = s.provider + (provider === selectedProvider ? ' ' + s.selected : '');

					let imgPath;
					if (provider === 'cinema') {
						imgPath = '/logos/' + appData.styling.logoShade + '/' + cinemaLogo;
					} else {
						imgPath = '/logos/ticketproviders/' + appData.styling.logoShade + '/' + provider + '.png';
					}

					return (
						<div class={pClass} title={provider} onClick={this.selectProvider.bind(this, provider)}>
							<img src={`${appData.urls.roots.sharedImages}${imgPath}`} />
						</div>
					);
				})}
			</div>
		);
	}

}
